import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { RequestDemo } from './pages/RequestDemo';
import { Demo } from './pages/Demo';
import { Brossard } from './pages/Brossard';
import { CoreInfrastructure } from './pages/CoreInfrastructure';
import { DigitalCard } from './pages/DigitalCard';
import { Requests } from './pages/Requests';
import { SmartWater } from './pages/SmartWater';
import { Casselman } from './pages/Casselman';
import { Communications } from './pages/Communications';
import { Collect } from './pages/Collect';
import { Analytics } from './pages/Analytics';
import { Atna } from './pages/Atna';
import { Platform } from './pages/Platform';
import { CitiesGovernment } from './pages/CitiesGovernment';
import { AirportsTransportation } from './pages/AirportsTransportation';
import { TelecommunicationsMedia } from './pages/TelecommunicationsMedia';
import { HealthNetworks } from './pages/HealthNetworks';
import { UniversitiesCampuses } from './pages/UniversitiesCampuses';
import { Trust } from './pages/Trust';
import { About } from './pages/About';
import { AtnaLauncher } from './components/atna/AtnaLauncher';
import { LanguageProvider } from './components/LanguageContext';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/request-demo" element={<RequestDemo data-id="element-7" />} data-id="element-6" />
          <Route path="/demo" element={<Demo data-id="element-9" />} data-id="element-8" />
          <Route path="/brossard" element={<Brossard data-id="element-11" />} data-id="element-10" />
          <Route path="/core-infrastructure" element={<CoreInfrastructure data-id="element-13" />} data-id="element-12" />
          <Route path="/digital-card" element={<DigitalCard data-id="element-15" />} data-id="element-14" />
          <Route path="/requests" element={<Requests data-id="element-17" />} data-id="element-16" />
          <Route path="/smart-water" element={<SmartWater data-id="element-19" />} data-id="element-18" />
          <Route path="/casselman" element={<Casselman data-id="element-21" />} data-id="element-20" />
          <Route path="/communications" element={<Communications data-id="element-23" />} data-id="element-22" />
          <Route path="/collect" element={<Collect data-id="element-25" />} data-id="element-24" />
          <Route path="/analytics" element={<Analytics data-id="element-27" />} data-id="element-26" />
          <Route path="/atna" element={<Atna data-id="element-29" />} data-id="element-28" />
          <Route path="/trust" element={<Trust data-id="element-31" />} data-id="element-30" />
          <Route path="/about" element={<About data-id="element-33" />} data-id="element-32" />
          <Route path="/platform" element={<Platform data-id="element-35" />} data-id="element-34" />
          <Route path="/cities-government" element={<CitiesGovernment data-id="element-37" />} data-id="element-36" />
          <Route path="/industries/cities-government" element={<CitiesGovernment data-id="element-39" />} data-id="element-38" />
          <Route path="/industries/airports" element={<AirportsTransportation data-id="element-41" />} data-id="element-40" />
          <Route path="/industries/telecom" element={<TelecommunicationsMedia data-id="element-43" />} data-id="element-42" />
          <Route path="/industries/health" element={<HealthNetworks data-id="element-45" />} data-id="element-44" />
          <Route path="/industries/universities" element={<UniversitiesCampuses data-id="element-47" />} data-id="element-46" />
        </Routes>
        <AtnaLauncher data-id="element-48" />
      </BrowserRouter>
    </LanguageProvider>;
}